import Logo from 'components/template/Logo'
import { Button, Drawer } from 'components/ui'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setPlanPanelExpand } from 'store/checkout/selectPlanSlice'
import useResponsive from 'utils/hooks/useResponsive'
import SelectPlanPanelContent from './PanelContent'
import { apiGetTermsOfUse } from 'services/CommonService'
import { ADMIN, USER } from 'constants/roles.constant'

const SelectPlan = () => {
    const userAuthority = useSelector((state) => state.auth.user.authority)
    const { windowHeight } = useResponsive()
    const [termsOfUseContent, setTermsOfUseContent] = useState('')

    const dispatch = useDispatch()

    const selectPlanPanelExpand = useSelector(
        (state) => state.checkout.selectPlan.planPanelExpand
    )

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiGetTermsOfUse()
            if (response.data) {
                setTermsOfUseContent(response.data.text)
            }
        }
        if (userAuthority.includes(USER) || userAuthority.includes(ADMIN)) {
            fetchData()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAuthority])

    const onDrawerClose = () => {
        dispatch(setPlanPanelExpand(false))
        const bodyClassList = document.body.classList
        if (bodyClassList.contains('drawer-lock-scroll')) {
            bodyClassList.remove('drawer-lock-scroll', 'drawer-open')
        }
    }

    const Header = (
        <div className="w-full">
            <div className="flex justify-between items-center">
                <Logo />
                <h4 className="mb-2">Set up your subscription</h4>
                <Button onClick={onDrawerClose} size="sm">
                    Go Back
                </Button>
            </div>
        </div>
    )

    return (
        <Drawer
            title={Header}
            isOpen={selectPlanPanelExpand}
            onClose={onDrawerClose}
            onRequestClose={onDrawerClose}
            placement="bottom"
            height={windowHeight}
            bodyClass="p-0"
            overlayClassName="z-40"
        >
            <SelectPlanPanelContent termsOfUseContent={termsOfUseContent} />
        </Drawer>
    )
}

export default SelectPlan
